import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ULThemeTitleProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * The title of the screen.
   */
  children: ReactNode;
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
  /**
   * Style variant override
   */
  variant?: "default" | "custom";
}

const ULThemeTitle = ({
  children,
  className,
  variant = "default",
  ...rest
}: ULThemeTitleProps) => {
  const themedStyles =
    "mt-3 mb-2 sm:mt-6 sm:mb-4 text-header justify-text-header text-(length:--ul-theme-font-title-size)";

  const variantOverrides = {
    default: "font-title",
    custom: "font-[850] italic",
  };

  const variantClasses = variant && variantOverrides[variant];

  return (
    <h1 className={cn(themedStyles, variantClasses, className)} {...rest}>
      {children}
    </h1>
  );
};

export default ULThemeTitle;
